import { AppleFreeTrialExp2Variants } from '.';

export const priceByCountry = {
	US: '$9.99',
	UK: '£8.99',
	GB: '£8.99',
	CA: 'CA$12.99',
	AU: 'AU$12.99',
};

export const exp2AffiliateLinksParams: Record<
	AppleFreeTrialExp2Variants,
	Record<'freeTrial' | 'regular', { ct: string; itsct: string }>
> = {
	control: {
		freeTrial: {
			ct: 'exp-2-control-natds',
			itsct: 'justwatch_tv_6',
		},
		regular: {
			ct: 'exp-2-control-reg',
			itsct: 'justwatch_tv',
		},
	},
	variant_1: {
		freeTrial: {
			ct: 'exp-2-v1-natds',
			itsct: 'justwatch_tv_13',
		},
		regular: {
			ct: 'exp-2-v1-reg',
			itsct: 'justwatch_tv',
		},
	},
};
